import Phaser from "phaser";
import "./styles.css";
import { BootScene } from "./scenes/BootScene";
import { GameScene } from "./scenes/GameScene";
import { ChapterIntroScene } from "./scenes/ChapterIntroScene";
import { LevelSelectScene } from "./scenes/LevelSelectScene";
import { LoadoutScene } from "./scenes/LoadoutScene";
import { MainMenuScene } from "./scenes/MainMenuScene";
import { PreloadScene } from "./scenes/PreloadScene";
import { ResultsScene } from "./scenes/ResultsScene";
import { ProgressionScene } from "./scenes/ProgressionScene";
import { UIScene } from "./scenes/UIScene";
import { MultiplayerLobbyScene } from "./scenes/MultiplayerLobbyScene";
import { CoopBattleScene } from "./scenes/CoopBattleScene";
import { installGlobalObservability } from "./systems/analytics";

installGlobalObservability();

new Phaser.Game({
  type: Phaser.WEBGL,
  parent: "game",
  backgroundColor: "#171512",
  scale: {
    mode: Phaser.Scale.RESIZE,
    autoCenter: Phaser.Scale.CENTER_BOTH,
    width: window.innerWidth,
    height: window.innerHeight,
  },
  render: { antialias: true, pixelArt: false, roundPixels: true },
  input: { activePointers: 3 },
  scene: [
    BootScene,
    PreloadScene,
    MainMenuScene,
    MultiplayerLobbyScene,
    CoopBattleScene,
    ProgressionScene,
    LevelSelectScene,
    LoadoutScene,
    ChapterIntroScene,
    GameScene,
    UIScene,
    ResultsScene,
  ],
});
